export enum AgrnBssCd {
  UV = 'UV',
  PURCHASE = 'PURCHASE',
}
